import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const sectionStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`;

const eyebrowStyle = css`
	${theme.typography.eyebrow}
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

const blockStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding: 1rem 1.25rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
`;

const blockTitleStyle = css`
	${theme.typography.stateTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

const blockTextStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

/** The purge state and the audit-trail reminder; the server exposes no schedule or count to show. */
const PurgeStatus: React.FC = () => {
	return (
		<section css={sectionStyle}>
			<span css={eyebrowStyle}>État de la purge</span>
			<div css={blockStyle}>
				<h3 css={blockTitleStyle}>Purge automatique active</h3>
				<p css={blockTextStyle}>Exécutée chaque nuit, sur les seuls éléments échus.</p>
			</div>
			<div css={blockStyle}>
				<p css={blockTextStyle}>
					Le journal d'audit est conservé indépendamment : la suppression d'un dossier n'efface pas
					les entrées qui le concernent.
				</p>
			</div>
		</section>
	);
};

export default PurgeStatus;
